module.exports = __webpack_public_path__ + "img/web4.11abae96.png";